import Splide from '@splidejs/splide';

export default class ReviewsSlider {
    constructor() {
        this.reviewsSlider = document.querySelector('.jsFpReviewsSlider');

        if (this.reviewsSlider) {
            this.events();
        }
    }

    events() {
        this.initializeReviewsSlider();
    }

    initializeReviewsSlider() {
        // eslint-disable-next-line no-unused-vars
        this.activeSlider = new Splide(this.reviewsSlider, {
            type: 'loop',
            perPage: 1,
            perMove: 1,
            rewind: false,
            arrows: true,
            pagination: false,
            autoplay: true,
            interval: 2000,
            gap: '1.25rem',
            padding: '4.75rem',
            classes: {
                // Add classes for arrows.
                arrows: 'fpr-slider__arrows',
                arrow: 'fpr-slider__arrow',
                prev: 'fpr-slider__arrow--prev',
                next: 'fpr-slider__arrow--next',
            },
            breakpoints: {
                767: {
                    arrows: false,
                    gap: '0.6875rem',
                    padding: { right: '3.4375rem' },
                },
                575: {
                    padding: { right: '2.1875rem' },
                },
            },
        }).mount();
    }
}
